import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { useTutorialsModel } from '@models/Tutorials/TutorialsModel';
import { ToastService } from '@services';
import { parseApiError } from '@utils';
import { TextTouchable } from '@components';
import { useTagsModel } from '@models/Tags/TagsModel';

const TextContainer = styled(View)({
  position: 'absolute',
  top: -56,
  right: 0,
});

const TextLabelTouchable = styled(TextTouchable)({
  color: '$text400',
  variant: 'text.medium',
});

export const ClearFiltersLabel = observer(() => {
  const { t } = useTranslation();
  const tutorial = useTutorialsModel();
  const tags = useTagsModel();

  async function clearFilters() {
    try {
      tutorial.categories.clearFilters();
      tags.recommended.clearTagsSelection();

      await tutorial.list.fetch.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  return (
    <TextContainer>
      <TextLabelTouchable onPress={clearFilters}>
        {t('hub.clearFilters')}
      </TextLabelTouchable>
    </TextContainer>
  );
});
